/* eslint-disable @typescript-eslint/no-unused-expressions */
import { notification } from 'antd'
import { useMutation, useQueryClient } from 'react-query'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { QUERY_KEYS } from '@api'

import { DriversApi } from '../useCreateDriver/api'

const useDrivers = () => {
  const [isAddDriverModalOpen, setIsAddDriverModalOpen] = useState(false)
  const [isEditDriverModalOpen, setIsEditDriverModalOpen] = useState(false)
  const [isViewDriverModalOpen, setIsViewDriverModalOpen] = useState(false)

  const queryClient = useQueryClient()
  const { t } = useTranslation()

  const onAddDriverSuccess = () => {
    notification.success({
      message: t('Driver added successfully'),
    })
    setIsAddDriverModalOpen(false)
    queryClient.invalidateQueries(QUERY_KEYS.DRIVERS)
  }

  const onAddDriverError = () => {
    notification.error({
      message: t('Error adding driver'),
    })
  }

  const { mutate: addDriver, isLoading: addDriverLoading } = useMutation(DriversApi.createDriver, {
    onSuccess: onAddDriverSuccess,
    onError: onAddDriverError,
  })

  const openEditDriverModal = () => {
    setIsEditDriverModalOpen(true)
  }

  const closeEditDriverModal = () => {
    setIsEditDriverModalOpen(false)
  }

  return {
    addDriver,
    addDriverLoading,
    isAddDriverModalOpen,
    setIsAddDriverModalOpen,
    isEditDriverModalOpen,
    setIsEditDriverModalOpen,
    openEditDriverModal,
    closeEditDriverModal,
    isViewDriverModalOpen,
    setIsViewDriverModalOpen,
  }
}

export { useDrivers }
